import { render, staticRenderFns } from "./HospitalAdminView.vue?vue&type=template&id=04d40c0e"
import script from "./HospitalAdminView.vue?vue&type=script&lang=js"
export * from "./HospitalAdminView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports